(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));

        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  (() => {
    const CARD_SELECTOR = '.product-grid__item[data-hover-video-enabled="true"]';

    function getHoverVideo(card) {
      const videos = card.querySelectorAll('video');

      if (!videos.length) return null;

      return (
        card.querySelector(
          '[data-hover-media] video, [data-secondary-media] video, .product-card__media--secondary video, .product-card__media--hover video, .product-card-hover video'
        ) || videos[videos.length - 1]
      );
    }

    function prepareVideo(video) {
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.controls = false;

      video.setAttribute('muted', '');
      video.setAttribute('loop', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
    }

    function playCardVideo(card) {
      const video = getHoverVideo(card);

      if (!video) return;

      prepareVideo(video);

      const playPromise = video.play();

      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    }

    function stopCardVideo(card) {
      const video = getHoverVideo(card);

      if (!video) return;

      video.pause();

      try {
        video.currentTime = 0;
      } catch (error) {}
    }

    function initHoverVideo(container) {
      if (container.dataset.hoverVideoInitialized === 'true') return;

      container.dataset.hoverVideoInitialized = 'true';

      container.addEventListener('pointerover', event => {
        const card = event.target.closest(CARD_SELECTOR);

        if (!card || !container.contains(card)) return;
        if (event.relatedTarget && card.contains(event.relatedTarget)) return;

        playCardVideo(card);
      });

      container.addEventListener('pointerout', event => {
        const card = event.target.closest(CARD_SELECTOR);

        if (!card || !container.contains(card)) return;
        if (event.relatedTarget && card.contains(event.relatedTarget)) return;

        stopCardVideo(card);
      });
    }

    document.addEventListener('DOMContentLoaded', () => {
      document
        .querySelectorAll('results-list.product-grid-container')
        .forEach(initHoverVideo);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
